import { FUNCTIONALITY, GTAG, RGPD_SET_EVERYTHING } from '../actions/rgpd';

export default (
  state: RGPDState = {
    visible: true,
    options: {
      [FUNCTIONALITY]: true,
      [GTAG]: false,
    },
  },
  action: Record<string, any>
): RGPDState => (action.type === RGPD_SET_EVERYTHING ? action.payload : state);

export type RGPDState = {
  visible: boolean;
  options: Record<string, boolean>;
};
